// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#purchase
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackPurchaseItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackPurchaseParameters
    extends TrackEventListParameters<
        "coupon" | "currency" | "payment_type" | "shipping" | "shipping_tier" | "tax" | "value",
        null,
        TrackPurchaseItem
    > {}

const trackPurchase = (parameters: TrackPurchaseParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "purchase", ...parameters }, options);
};

export default trackPurchase;
